import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'pz-map',
    templateUrl: 'map-pick.component.html'
})

export class MapPickComponent implements OnInit {
    @Input()
    public key = 'OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77';

    @Output()
    public em: EventEmitter<any> = new EventEmitter();
    public url: SafeResourceUrl;
    @Input()
    set local(val) {
        this.url = this.dom.bypassSecurityTrustResourceUrl(
            `//apis.map.qq.com/tools/locpicker?search=1&type=1&key=${ this.key }&referer=myapp&coord=${val}`);
    }

    public constructor(private dom: DomSanitizer) {}

    public ngOnInit() {
        window.addEventListener('message', (event) => {
            const loc = event.data;
            console.log(loc);
            if (loc && loc.module === 'locationPicker') {
                this.em.emit(loc);
            }
        }, false);
    }
}
